import { useDate } from '@/hooks/useDate';
import { Tooltip } from '@mui/material';
import { ICellRendererParams } from 'ag-grid-community';
import { FunctionComponent } from 'react';

export const DateCellRenderer: FunctionComponent<ICellRendererParams<unknown>> = (props: ICellRendererParams<unknown>) => {
  const { formatDate, formatDateTimestamp } = useDate();

  return (
    <Tooltip title={formatDateTimestamp(props.value)} placement="left">
      <div>{formatDate(props.value)}</div>
    </Tooltip>
  );
};
